import React from 'react';
import { ReactComponent as Signature } from '../assets/image2vector.svg';
import './AtaturkSignature.css';

const AtaturkSignature = () => {
  return (
    <div className="signature-container">
      <Signature />
    </div>
  );
};

export default AtaturkSignature; 